import { createAction } from 'typesafe-actions';

export const afterAuthenticatedAppDidMount = createAction('app/AFTER_AUTHENTICATED_APP_DID_MOUNT')();

export const afterNavigation = createAction('app/AFTER_NAVIGATIOn')();
